import { gql, useMutation } from '@apollo/client'

export const DELETE_NOTIFICATIONS = gql`
  mutation MyMutation($notifications: [NotificationsDelete]) {
    deleteNotification(notifications: $notifications) {
      result
    }
  }
`

export const useDeleteNotifications = () => {
  const [mutate, { data, error, loading }] = useMutation(DELETE_NOTIFICATIONS, {
    update(cache) {
      cache.modify({
        fields: {
          getNotifications() {}
        }
      })
    }
  })

  return { mutate, data, error, loading }
}
